import TabbedPage from 'components/tabbed-page';
import SettingsTab from './settings-tab';
import LookupTab from './lookup-tab';
import RevealTab from './reveal-tab';

/**
 * Watermark chống lộ (docs/watermark/README.md): cài đặt lớp chữ mờ trên app +
 * trang Quản trị, tra mã truy vết ra tài khoản, soi lớp mã ẩn trên ảnh bị lộ.
 * ADMIN + MOD xem/tra/soi; chỉ ADMIN lưu cài đặt.
 */
const WatermarkManagerPage = () => (
  <TabbedPage
    title="Watermark"
    tabs={[
      { key: 'settings', label: 'Cài đặt', render: () => <SettingsTab /> },
      { key: 'lookup', label: 'Tra mã', render: () => <LookupTab /> },
      { key: 'reveal', label: 'Soi ảnh', render: () => <RevealTab /> },
    ]}
  />
);

export default WatermarkManagerPage;
